import { Topbar } from '@nbirl/nbi-common-ui-libs';

import { useBodyClassName } from '../hooks';

export const UnauthenticatedLayout = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  useBodyClassName('bg-primary-25');

  return (
    <div className="h-screen">
      <Topbar justify="center" className="fixed w-full" />
      <div className="pt-20 h-full w-full overflow-hidden">
        <main className="h-full w-full flex flex-col justify-center overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};
